import { useEffect, useState } from "react";

import { APP_VERSION, BUILD_TIME } from "@/version";

const VersionIndicator = () => {
  const [version, setVersion] = useState<string>("0.0.0");
  const [buildTime, setBuildTime] = useState<string>("");

  useEffect(() => {
    setVersion(APP_VERSION);
    setBuildTime(new Date(BUILD_TIME).toLocaleDateString("es-ES"));
  }, []);

  return (
    <div className="fixed bottom-2 left-2 z-50">
      <div className="rounded-md border border-white/20 bg-black/80 px-2 py-1 text-xs text-white backdrop-blur-sm">
        <div className="flex items-center gap-1">
          <span className="font-mono">v{version}</span>
          <span className="text-white/60">•</span>
          <span className="text-white/60">{buildTime}</span>
        </div>
      </div>
    </div>
  );
};

export default VersionIndicator;
